import { TypographyHeadings, TypographyTextStyles, TypographyDisplayHeadings } from "../../../../src/examples/foundations/Typography";
import * as React from 'react';
export default {
  TypographyHeadings,
  TypographyTextStyles,
  TypographyDisplayHeadings,
  React
};